import React from 'react';
import Section from '../components/ui/Section';
import Button from '../components/ui/Button';
import { FiCheck } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const ThankYou = () => {
  return (
    <div className="pt-24 min-h-[85vh] flex flex-col justify-center items-center">
      <Section className="w-full pb-12 md:pb-24">
        <div className="max-w-3xl mx-auto text-center border border-brand-text/10 p-12 md:p-24 bg-brand-text/5 relative overflow-hidden">
          {/* Accent Line */}
          <div className="absolute top-0 left-0 w-full h-1 bg-brand-text"></div>
          
          <div className="w-20 h-20 mx-auto border border-brand-text/20 flex items-center justify-center rounded-full bg-brand-bg text-brand-text mb-8">
            <SafeIcon icon={FiCheck} className="text-3xl" />
          </div>
          
          <h1 className="text-5xl md:text-7xl mb-6 leading-none">
            VIELEN DANK.
          </h1>
          
          <p className="font-inter text-brand-text/70 text-lg mb-12 max-w-lg mx-auto leading-relaxed">
            Ihre Anfrage wurde erfolgreich übermittelt. Unser Team wird Ihre Angaben prüfen und sich schnellstmöglich mit Ihnen in Verbindung setzen, um die nächsten Schritte zu besprechen.
          </p>
          
          <Button to="/" showArrow className="mx-auto">
            Zurück zur Startseite
          </Button>
        </div>
      </Section>
    </div>
  );
};

export default ThankYou;